import { useMemo, useCallback } from "react";
import { AppTester } from "supporting";
import { logoList } from "./const/logoList";
import {
  Colors,
  ExternalLink,
  NavbarBContextSelectIcon,
  NavbarBurger,
  NavbarCloseIconWithBorder, NavbarThreeLinesIcon,
  NeutralLink,
  useBreakpoint,
  useIsMobile
} from "@brg/ui";
import { LinkTo } from "shared/constants/linkTo";
import { ApplicationShared, LayoutConst, modalControllerActions, modalControllerSelector, ModalControllerSlice, useModal } from "core";
import { useDispatch, useSelector } from "react-redux";
import { NavbarSearchSelector } from "shared/reducers/NavbarSearch";
import { DafesStyles, SimpleLogoContainer } from "./style";
import { MediiiaLogo } from "shared/navbars/logos/MediiiaLogo";
import { useHistory, useRouteMatch } from "react-router-dom";
import { OrganizationsState } from "shared/reducers/OrganizationsSlice";
import { NavbarBlackOrWhite } from "./components/NavbarBlackOrWhite";
import { MobileMenuStateAction } from "shared/reducers/mobileMenuOpen";
import { setIsOpen } from "shared/reducers/OpenModal";
import { LPULogo } from "../../navbars/logos/LPULogo";
import extractDomain from "shared/utils/extractDomain";

export const AGEYTOMESH_LOGO_LENGTH = 182;

export const useGetLogo = ({ isFooter, navDisabled }: { isFooter?: boolean, navDisabled?: boolean }) => {
  const modal = useModal();
  const dispatch = useDispatch();
  const history = useHistory();
  const isHSEDesigner = useSelector(NavbarSearchSelector).isHseDesigner;
  const isTagsModalActive = useSelector(modalControllerSelector).name === 'tags';
  const isCompetitionSendProjectActive =
    useSelector(modalControllerSelector).name === "send-project";
  const isHSEDesign = AppTester.isHSEDesign();
  const isHseColors = AppTester.isHseColors();
  const isLMSHSECreative = AppTester.isLMSHSECreative();
  const isDaMuseum = AppTester.isDaMuseum();
  const isSchool = AppTester.isSchool();
  const isGeo = AppTester.isGeograffee();
  const isCreativeHSE = AppTester.isCreativeHSE();
  const logoShifted = useSelector((state: any) => state.animations.logoShifted);
  const isEditPage = useRouteMatch(LinkTo.projectEdit);
  const isTeamEdit = useRouteMatch('/team-edit');
  const isTeamOrCoursePage = !!useRouteMatch(['/teams', '/courses']);
  const isCompetitionEdit = useRouteMatch('/competition-edit');
  const isBookEdit = useRouteMatch('/book-edit');
  const isHSEBookEdit = useRouteMatch(['/books/book-edit', '/books/edit']);
  const isProjectPage = useRouteMatch(LinkTo.project);
  const isMain = !!useRouteMatch('/')?.isExact;
  const isForcedLanding = !!useRouteMatch('/brnd')?.isExact
  const storedTeam = useSelector((store: { organizations: OrganizationsState }): any => store.organizations.team);
  //@ts-ignore
  const isOpen = useSelector((state) => state.openModal.isOpen);
  const isTablet = useBreakpoint(LayoutConst.screen.l);
  const isProfile = !!useRouteMatch([LinkTo.designer, LinkTo.designerEdit]);

  const isMainPage = isMain || isForcedLanding;
  const isAgeytomesh = AppTester.isAgeytomesh();
  const isHseAnimation = AppTester.isHseAnimation();
  const isBooksGallllery = AppTester.isBooksGallllery();
  const isMedia = AppTester.isMediiia();
  const isOnlines = AppTester.isOnlines();
  const isMobile = useIsMobile();
  const isTab = useBreakpoint(1200)
  const is992BP = useBreakpoint(LayoutConst.screen.m);
  const is1200BP = useBreakpoint(LayoutConst.screen.l);
  const isSuperPuper = AppTester.isSuperPuper();
  const isProDeziiign = AppTester.isProDeziiign();
  const isBookDeziiign = AppTester.isBooksDeziiign();
  const isFashion = AppTester.isFashionDeziiign();
  const isLpu = AppTester.isLPUDesign();
  const isGame = AppTester.isGameDeziiign();
  const isDvaDesign = AppTester.isDvaDesign();
  const isGalllleryArt = AppTester.isGalllleryArt();
  const isBrnd = AppTester.isBrnd();
  const isStartup = !!useRouteMatch('/startup')?.isExact;
  const isCGRAVE = AppTester.isCGRAVE();
  const isAdcrDafesNet = AppTester.isAdcrDafesNet();
  const isGreenAward = AppTester.isGreenAward();
  const isContinuumSite = AppTester.isContinuumSite();
  const isDafes = AppTester.isGeoDafes();
  const isPortfoli365 = AppTester.isPortfolio365();
  const isDeziiign = AppTester.isDeziiign();
  const isDezignMain = AppTester.isDeziiignMain();
  const isCompetition = AppTester.isCompetition();
  const isAcademy = AppTester.isAcademy();
  const isLPU = AppTester.isLPUDesign();
  const isStartHSE = AppTester.isStartHSE();
  const isProHSE = AppTester.isProHSE();
  const isMediiiaUrban = AppTester.isMediiiaUrban();
  const isKiidsArt = AppTester.isKiiidsArt()
  const isHseSpace = AppTester.isHseSpace();
  const isLabDeziiign = AppTester.isLabDeziiign();
  const isMonaLisaTravels = AppTester.isMonaLisaTravels();

  const { name: modalName }: ModalControllerSlice = useSelector(
    modalControllerSelector
  );

  let ctx = (ApplicationShared.application.split('/')[1] || ApplicationShared.application);

  const navbarTheme = useMemo(
    () => isMedia || isHSEDesign || isDeziiign || isCompetition ? 'white' : 'black'
    , [isMedia, isDeziiign, isHSEDesign, isCompetition])

  const getContextTitle = (t: string) => {
    if (isSuperPuper) {
      return 'superpuper.'
    }
    if (isCGRAVE) {
      return ''
    }
    if (isAdcrDafesNet) {
      return ''
    }
    if (isGreenAward) {
      return ''
    }
    if (isHseAnimation) {
      return ''
    }
    if (t === 'main') return 'deziiign';
    if (t === 'mediiia') return 'mediiia';
    if (isHSEDesign) return 'deziiign';
    else {
      if (isAgeytomesh || isKiidsArt) return '';
      return `.deziiign`
    }
  }

  const prefixColor = useMemo(() => {
    if (isCompetition) {
      return '#FF0000'
    }
    if (isMedia) {
      return '#609AF0'
    }
    if (isBrnd) {
      return '#00AA01'
    }
    if (isCGRAVE) {
      return '#FEFEFE'
    }
    if (isAdcrDafesNet) {
      return '#FEFEFE'
    }
    if (isGreenAward) {
      return '#89B644'
    }
    if (isContinuumSite) {
      return '#0099E0'
    }
    if (isBooksGallllery) {
      return '#151514'
    }
  }, [
    isCompetition,
    isMedia,
    isBrnd,
    isCGRAVE,
    isAdcrDafesNet,
    isGreenAward,
    isContinuumSite
  ])

  const postfixColor = useMemo(() => {
    if (isCompetition) {
      return '#151514'
    }
    if (isContinuumSite || isGame) {
      return '#FEFEFE'
    }
  }, [isCompetition, isContinuumSite])

  const getTitleOrLogo = ({ hasPrefix }: { hasPrefix?: boolean }) => {

    if (!isHSEDesigner && !isProHSE && isProfile && (isHSEDesign || isSchool)) {
      return 'deziiign'
    }

    let Logo;

    if (isHSEDesign || isSchool || isLMSHSECreative) {
      Logo = logoList['hsedesign']
    }
    if (isHseSpace) {
      Logo = logoList['hsespace']
    }
    if (isLpu) {
      Logo = logoList['lpu']
    }
    if (isHseColors) {
      Logo = logoList['hsecolors']
    }
    if (isBrnd) {
      Logo = logoList['brnd']
    }
    if (isOnlines) {
      Logo = logoList['onlines']
    }
    if (isPortfoli365) {
      Logo = logoList['portfolio365']
    }

    if (isKiidsArt) {
      Logo = logoList['kiiids']
    }
    if (isHseAnimation) {
      return 'hseanimation';
    }

    if (Logo) {
      return <Logo
        onClick={onClick}
        isFooter={false}
      />
    }

    if (isDafes) {
      return 'dafes';
    }
    if (isAcademy) {
      return 'academy'
    }
    if (isGeo) {
      return 'geograffee'
    }
    if (isSuperPuper) {
      return 'games';
    }
    if (isBooksGallllery) {
      return 'gallllery';
    }
    if (isCGRAVE) {
      return ''
    }
    if (isAdcrDafesNet) {
      return ''
    }
    if (isGreenAward) {
      return ''
    }
    if (isContinuumSite) {
      return '.site'
    }
    if (isMedia) {
      return hasPrefix ? '.mediiia' : 'mediiia';
    }
    if (isAgeytomesh) {
      return 'agey tomesh';
    }
    if (isMonaLisaTravels) {
      return 'Mona Lisa Travels'
    }
    if (isGalllleryArt) {
      return 'gallllery.art'
    }
    if (isDvaDesign) {
      return 'dva.design'
    }

    return getContextTitle(ctx);
  }

  const getPrefixName = () => {
    if (isLabDeziiign) {
      return 'lab'
    }
    if (isMediiiaUrban) {
      return 'urban'
    }
    if (isCompetition) {
      return 'awards'
    }
    if (isSuperPuper) {
      return 'superpuper.'
    }
    if (isBooksGallllery) {
      return 'books'
    }
    if (isCGRAVE) {
      return 'CG RAVE'
    }
    if (isAdcrDafesNet) {
      return 'ADCR'
    }
    if (isGreenAward) {
      return 'ЗЕЛЕНАЯ ПРЕМИЯ'
    }
    if (isContinuumSite) {
      return 'continuum'
    }
    if (isDafes || isProHSE) {
      return ''
    }
    if (isAcademy) {
      return 'creativecity.'
    }
    if (isBrnd) {
      if (isStartup) {
        return 'startup'
      }
      return ''
    }
    if (
      isGame ||
      isBookDeziiign ||
      isFashion ||
      isProDeziiign
    ) {
      return ctx;
    }
    return null;
  }

  const onClick = () => {
    if (isPortfoli365) {
      window.open(process.env.REACT_APP_URL_PORTFOLIO_365, '_self')
      return
    }
    if (isKiidsArt) {
      window.open(process.env.REACT_APP_URL_KIIIDS_ART, '_self')
      return
    }
    return
  }

  const onBurgerClick = useCallback(() => {
    if (
      modalName) {
      dispatch(modalControllerActions.hideModal({}));
    } else {

      if (isMobile || isTab) {
        dispatch(MobileMenuStateAction.toggle(!isOpen));
        dispatch(setIsOpen(!isOpen));
      } else {
        modal.show('context-new', {
          orientation: isHseSpace ? 'right' : 'center'
        });
      }
    }
  }, [
    isTagsModalActive,
    dispatch,
    modal,
    isMobile,
    isOpen,
    isCompetitionSendProjectActive
  ])

  const onLogoClick = useCallback((e: any) => {
    if (isPortfoli365) {
      window.open(process.env.REACT_APP_URL_PORTFOLIO_365, '_self')
      return
    }
    if (isKiidsArt) {
      window.open(process.env.REACT_APP_URL_KIIIDS_ART, '_self')
      return
    }
    if (isFooter && isMedia) {
      window.open(window.location.origin.endsWith('ru') ? process.env.REACT_APP_URL_MEDIIIA_RU : process.env.REACT_APP_URL_MEDIIIA_COM, '_self')
      return
    }
    if ((isAgeytomesh || isDvaDesign) && isMainPage && !!storedTeam?.longread && !storedTeam?.isLongreadDisabled) {
      e.preventDefault();
      e.stopPropagation();
      const path = isForcedLanding ? '/' : '/brnd';
      history.push(path);
    }
  }, [
    isFooter,
    isMedia,
    isPortfoli365,
    isAgeytomesh,
    isDvaDesign,
    isMainPage,
    storedTeam?.longread,
    storedTeam?.isLongreadDisabled,
    isForcedLanding,
    history
  ])

  const logoHref = useMemo(() => {
    if (isPortfoli365) {
      return process.env.REACT_APP_URL_PORTFOLIO_365;
    }
    if (isKiidsArt) {
      return process.env.REACT_APP_URL_KIIIDS_ART;
    }
    if (isFooter && isMedia) {
      return window.location.origin.endsWith('ru') ? process.env.REACT_APP_URL_MEDIIIA_RU : process.env.REACT_APP_URL_MEDIIIA_COM;
    }
    if ((isAgeytomesh || isDvaDesign) && isMainPage && !!storedTeam?.longread && !storedTeam?.isLongreadDisabled) {
      return isForcedLanding ? '/' : '/brnd';
    }
    return null;
  }, [isPortfoli365, isKiidsArt, isFooter, isMedia, isAgeytomesh, isDvaDesign, isMainPage, storedTeam?.longread, storedTeam?.isLongreadDisabled, isForcedLanding]);

  const prefixHref = useMemo(() => {
    return '/';
  }, [
    isFooter,
    isMedia,
    isPortfoli365,
    isAgeytomesh,
    isDvaDesign,
    isMainPage,
    storedTeam?.longread,
    storedTeam?.isLongreadDisabled,
    isForcedLanding,
    history
  ]);

  const prefixName = getPrefixName();
  const mainLogo = getTitleOrLogo({ hasPrefix: !!prefixName?.length });

  const simpleLogoVisible = useMemo(
    () => ((isHSEDesign || isSchool) && isHSEDesigner && !isDaMuseum) || isMedia || isLPU
    , [isHSEDesign, isDaMuseum, isHSEDesigner, isMedia, isSchool, isLPU])


  const shouldHideBurger = useMemo(() => {

    const isRestrictedFor1200BP = [
      isDaMuseum,
      isAgeytomesh,
      isHseAnimation,
      isContinuumSite,
      isDvaDesign,
      isGalllleryArt,
      isCGRAVE,
      isAdcrDafesNet,
      isGreenAward,
      isBrnd,
      isLPU,
      !!isCompetitionEdit,
      !!isHSEBookEdit
    ].some(Boolean) && !is1200BP;

    const isRestrictedForTablet = [
      isDafes,
      isGeo && !isDafes,
      isHseSpace,
      isHseColors,
      isCreativeHSE,
      isSchool,
      isPortfoli365,
      isLMSHSECreative,
      isKiidsArt
    ].some(Boolean) && !isTablet;

    const otherConditions = [
      isFooter,
      isMedia,
      isSuperPuper,
      !!isEditPage,
      !!isTeamEdit,
      !!isBookEdit,
      !!isCompetitionEdit,
      isMonaLisaTravels,
    ].some(Boolean);


    return isRestrictedFor1200BP || isRestrictedForTablet || otherConditions;
  }, [
    isAcademy,
    isTablet,
    isDafes,
    isGeo,
    isFooter,
    isDaMuseum,
    isHseAnimation,
    isHseColors,
    isLMSHSECreative,
    isCreativeHSE,
    isSchool,
    isAgeytomesh,
    isEditPage,
    isContinuumSite,
    isMedia,
    isBrnd,
    is992BP,
    isSuperPuper,
    isDvaDesign,
    isGalllleryArt,
    isCGRAVE,
    isAdcrDafesNet,
    isGreenAward,
    isPortfoli365,
    isLPU,
    is1200BP,
    isTeamEdit,
    isBookEdit,
    isCompetitionEdit,
    isHSEBookEdit,
    isHseSpace,
    isMonaLisaTravels,
  ]);

  const logoStyle = () => {
    if (!isFooter && isTablet) {
      return '3linesgrey'
    }
    if (isDafes) {
      return 'mobile';
    }
    if ((isDvaDesign || isAgeytomesh || isHseAnimation || isGalllleryArt || (isMedia && is992BP)) && !isFooter) {
      return '4lines';
    }
    return 'default'
  }

  const onMainContextClick = useCallback((e: any) => {
    e.preventDefault()
    e.stopPropagation()
    if (typeof mainLogo === 'string' && ['.deziiign', 'deziiign']?.includes(mainLogo)) {
      window.open(process.env.REACT_APP_URL_DEZIIIGN, '_self');
      return;
    }
    if (isBooksGallllery) {
      window.open(process.env.REACT_APP_URL_GALLERY, '_self')
      return
    }

    history.push('/')

  }, [mainLogo, history])

  const postfixHref = useMemo(() => {
    if (typeof mainLogo === 'string' && ['.deziiign', 'deziiign']?.includes(mainLogo)) {
      return process.env.REACT_APP_URL_DEZIIIGN;
    }
    if (isBooksGallllery) {
      return process.env.REACT_APP_URL_GALLERY;
    }

    return '/';
  }, [isPortfoli365, isKiidsArt, isBooksGallllery, mainLogo]);

  const handlers = {
    onClick: onBurgerClick,
    onBurgerClick,
  }

  const getNavbarProps = () => {
    if (isFooter) {
      return {
        theme: navbarTheme,
        title: mainLogo === '.deziiign' ? 'deziiign' : mainLogo,
        visiblePopUp: false,
        logoLength: AGEYTOMESH_LOGO_LENGTH,
        prefixName: mainLogo === '.deziiign' ? '' : prefixName,
        prefixColor: prefixColor,
        postfixColor: postfixColor,
        shouldHideBurger: true,
        logoStyle: "default",
        disabled: navDisabled,
        isFooter: true,
        ...(isAcademy && { postfixHref }),
        onBurgerClick: () => {
          return
        },
      }
    }
    return {
      theme: navbarTheme,
      title: isFooter && mainLogo === '.deziiign' ? 'deziiign' : mainLogo,
      ...(isDafes && isTablet && { earlyMobile: true }),
      visiblePopUp: isOpen || isTagsModalActive || !!modalName,
      logoLength: AGEYTOMESH_LOGO_LENGTH,
      prefixName: isFooter && mainLogo === '.deziiign' ? '' : prefixName,
      prefixColor: prefixColor,
      isLight: isBooksGallllery,
      postfixColor: postfixColor,
      shouldHideBurger: shouldHideBurger,
      logoStyle: logoStyle(),
      isShifted: (isAgeytomesh && logoShifted && isHseAnimation && !isMobile && !isEditPage && !isProjectPage),
      isOnlines: isOnlines,
      logoLikeTag: isAgeytomesh || isHseAnimation || isDvaDesign || isGalllleryArt || isMonaLisaTravels,
      disabled: navDisabled,
      onBurgerClick,
      logoHref,
      postfixHref,
      prefixHref,
    }
  }

  const handleReloadPage = useCallback(() => {
    if (isTeamOrCoursePage && isHSEDesign) {
      history.push(LinkTo.explore);
      window.location.reload();
    }
  }, [isTeamOrCoursePage, isHSEDesign]);

  if (simpleLogoVisible) {
    return (
      <SimpleLogoContainer align={'center'} style={{ maxWidth: isMedia ? 'none' : '490px' }}>
        {!shouldHideBurger && (
          <NavbarBurger
            style={{ marginRight: '8px', marginTop: isTablet ? '2px' : '0' }}
            {...handlers}
          >
            {isOpen || isTagsModalActive || !!modalName ? (
              <NavbarCloseIconWithBorder />
            ) : (
              (isTablet ? <NavbarThreeLinesIcon fill={Colors.galBlack47} /> : <NavbarBContextSelectIcon />)
            )}
          </NavbarBurger>
        )}
        {isMedia ? (
          <MediiiaLogo
            {...handlers}
            isFooter={isFooter}
            visiblePopUp={isOpen}
          />
        ) : isLPU ? (
          <LPULogo onClick={() => history.push('/')} />
        ) : isHseSpace? (
          <ExternalLink to={process.env.REACT_APP_URL_HSE_SPACE} title={extractDomain('/')}>
            {mainLogo}
          </ExternalLink>
        ) : (
          <NeutralLink to={LinkTo.explore} onClick={handleReloadPage} title={extractDomain('/')}>
            {mainLogo}
          </NeutralLink>
        )}
      </SimpleLogoContainer>
    )
  }

  return (
    <>
      {isDafes && <DafesStyles />}
      <NavbarBlackOrWhite isOpen={isOpen} isKiidsArt={isKiidsArt} {...getNavbarProps()} />
    </>
  )
}import { useMemo, useCallback } from "react";
import { AppTester } from "supporting";
import { logoList } from "./const/logoList";
import {
  Colors,
  ExternalLink,
  NavbarBContextSelectIcon,
  NavbarBurger,
  NavbarCloseIconWithBorder, NavbarThreeLinesIcon,
  NeutralLink,
  useBreakpoint,
  useIsMobile
} from "@brg/ui";
import { LinkTo } from "shared/constants/linkTo";
import { ApplicationShared, LayoutConst, modalControllerActions, modalControllerSelector, ModalControllerSlice, useModal } from "core";
import { useDispatch, useSelector } from "react-redux";
import { NavbarSearchSelector } from "shared/reducers/NavbarSearch";
import { DafesStyles, SimpleLogoContainer } from "./style";
import { MediiiaLogo } from "shared/navbars/logos/MediiiaLogo";
import { useHistory, useRouteMatch } from "react-router-dom";
import { OrganizationsState } from "shared/reducers/OrganizationsSlice";
import { NavbarBlackOrWhite } from "./components/NavbarBlackOrWhite";
import { MobileMenuStateAction } from "shared/reducers/mobileMenuOpen";
import { setIsOpen } from "shared/reducers/OpenModal";
import { LPULogo } from "../../navbars/logos/LPULogo";
import extractDomain from "shared/utils/extractDomain";

export const AGEYTOMESH_LOGO_LENGTH = 182;

export const useGetLogo = ({ isFooter, navDisabled }: { isFooter?: boolean, navDisabled?: boolean }) => {
  const modal = useModal();
  const dispatch = useDispatch();
  const history = useHistory();
  const isHSEDesigner = useSelector(NavbarSearchSelector).isHseDesigner;
  const isTagsModalActive = useSelector(modalControllerSelector).name === 'tags';
  const isCompetitionSendProjectActive =
    useSelector(modalControllerSelector).name === "send-project";
  const isHSEDesign = AppTester.isHSEDesign();
  const isHseColors = AppTester.isHseColors();
  const isLMSHSECreative = AppTester.isLMSHSECreative();
  const isDaMuseum = AppTester.isDaMuseum();
  const isSchool = AppTester.isSchool();
  const isGeo = AppTester.isGeograffee();
  const isCreativeHSE = AppTester.isCreativeHSE();
  const logoShifted = useSelector((state: any) => state.animations.logoShifted);
  const isEditPage = useRouteMatch(LinkTo.projectEdit);
  const isTeamEdit = useRouteMatch('/team-edit');
  const isTeamOrCoursePage = !!useRouteMatch(['/teams', '/courses']);
  const isCompetitionEdit = useRouteMatch('/competition-edit');
  const isBookEdit = useRouteMatch('/book-edit');
  const isHSEBookEdit = useRouteMatch(['/books/book-edit', '/books/edit']);
  const isProjectPage = useRouteMatch(LinkTo.project);
  const isMain = !!useRouteMatch('/')?.isExact;
  const isForcedLanding = !!useRouteMatch('/brnd')?.isExact
  const storedTeam = useSelector((store: { organizations: OrganizationsState }): any => store.organizations.team);
  //@ts-ignore
  const isOpen = useSelector((state) => state.openModal.isOpen);
  const isTablet = useBreakpoint(LayoutConst.screen.l);
  const isProfile = !!useRouteMatch([LinkTo.designer, LinkTo.designerEdit]);

  const isMainPage = isMain || isForcedLanding;
  const isAgeytomesh = AppTester.isAgeytomesh();
  const isHseAnimation = AppTester.isHseAnimation();
  const isBooksGallllery = AppTester.isBooksGallllery();
  const isMedia = AppTester.isMediiia();
  const isOnlines = AppTester.isOnlines();
  const isMobile = useIsMobile();
  const isTab = useBreakpoint(1200)
  const is992BP = useBreakpoint(LayoutConst.screen.m);
  const is1200BP = useBreakpoint(LayoutConst.screen.l);
  const isSuperPuper = AppTester.isSuperPuper();
  const isProDeziiign = AppTester.isProDeziiign();
  const isBookDeziiign = AppTester.isBooksDeziiign();
  const isFashion = AppTester.isFashionDeziiign();
  const isLpu = AppTester.isLPUDesign();
  const isGame = AppTester.isGameDeziiign();
  const isDvaDesign = AppTester.isDvaDesign();
  const isGalllleryArt = AppTester.isGalllleryArt();
  const isBrnd = AppTester.isBrnd();
  const isStartup = !!useRouteMatch('/startup')?.isExact;
  const isCGRAVE = AppTester.isCGRAVE();
  const isAdcrDafesNet = AppTester.isAdcrDafesNet();
  const isGreenAward = AppTester.isGreenAward();
  const isContinuumSite = AppTester.isContinuumSite();
  const isDafes = AppTester.isGeoDafes();
  const isPortfoli365 = AppTester.isPortfolio365();
  const isDeziiign = AppTester.isDeziiign();
  const isDezignMain = AppTester.isDeziiignMain();
  const isCompetition = AppTester.isCompetition();
  const isAcademy = AppTester.isAcademy();
  const isLPU = AppTester.isLPUDesign();
  const isStartHSE = AppTester.isStartHSE();
  const isProHSE = AppTester.isProHSE();
  const isMediiiaUrban = AppTester.isMediiiaUrban();
  const isKiidsArt = AppTester.isKiiidsArt()
  const isHseSpace = AppTester.isHseSpace();
  const isLabDeziiign = AppTester.isLabDeziiign();
  const isMonaLisaTravels = AppTester.isMonaLisaTravels();

  const { name: modalName }: ModalControllerSlice = useSelector(
    modalControllerSelector
  );

  let ctx = (ApplicationShared.application.split('/')[1] || ApplicationShared.application);

  const navbarTheme = useMemo(
    () => isMedia || isHSEDesign || isDeziiign || isCompetition ? 'white' : 'black'
    , [isMedia, isDeziiign, isHSEDesign, isCompetition])

  const getContextTitle = (t: string) => {
    if (isSuperPuper) {
      return 'superpuper.'
    }
    if (isCGRAVE) {
      return ''
    }
    if (isAdcrDafesNet) {
      return ''
    }
    if (isGreenAward) {
      return ''
    }
    if (isHseAnimation) {
      return ''
    }
    if (t === 'main') return 'deziiign';
    if (t === 'mediiia') return 'mediiia';
    if (isHSEDesign) return 'deziiign';
    else {
      if (isAgeytomesh || isKiidsArt) return '';
      return `.deziiign`
    }
  }

  const prefixColor = useMemo(() => {
    if (isCompetition) {
      return '#FF0000'
    }
    if (isMedia) {
      return '#609AF0'
    }
    if (isBrnd) {
      return '#00AA01'
    }
    if (isCGRAVE) {
      return '#FEFEFE'
    }
    if (isAdcrDafesNet) {
      return '#FEFEFE'
    }
    if (isGreenAward) {
      return '#89B644'
    }
    if (isContinuumSite) {
      return '#0099E0'
    }
    if (isBooksGallllery) {
      return '#151514'
    }
  }, [
    isCompetition,
    isMedia,
    isBrnd,
    isCGRAVE,
    isAdcrDafesNet,
    isGreenAward,
    isContinuumSite
  ])

  const postfixColor = useMemo(() => {
    if (isCompetition) {
      return '#151514'
    }
    if (isContinuumSite || isGame) {
      return '#FEFEFE'
    }
  }, [isCompetition, isContinuumSite])

  const getTitleOrLogo = ({ hasPrefix }: { hasPrefix?: boolean }) => {

    if (!isHSEDesigner && !isProHSE && isProfile && (isHSEDesign || isSchool)) {
      return 'deziiign'
    }

    let Logo;

    if (isHSEDesign || isSchool || isLMSHSECreative) {
      Logo = logoList['hsedesign']
    }
    if (isHseSpace) {
      Logo = logoList['hsespace']
    }
    if (isLpu) {
      Logo = logoList['lpu']
    }
    if (isHseColors) {
      Logo = logoList['hsecolors']
    }
    if (isBrnd) {
      Logo = logoList['brnd']
    }
    if (isOnlines) {
      Logo = logoList['onlines']
    }
    if (isPortfoli365) {
      Logo = logoList['portfolio365']
    }

    if (isKiidsArt) {
      Logo = logoList['kiiids']
    }
    if (isHseAnimation) {
      return 'hseanimation';
    }

    if (Logo) {
      return <Logo
        onClick={onClick}
        isFooter={false}
      />
    }

    if (isDafes) {
      return 'dafes';
    }
    if (isAcademy) {
      return 'academy'
    }
    if (isGeo) {
      return 'geograffee'
    }
    if (isSuperPuper) {
      return 'games';
    }
    if (isBooksGallllery) {
      return 'gallllery';
    }
    if (isCGRAVE) {
      return ''
    }
    if (isAdcrDafesNet) {
      return ''
    }
    if (isGreenAward) {
      return ''
    }
    if (isContinuumSite) {
      return '.site'
    }
    if (isMedia) {
      return hasPrefix ? '.mediiia' : 'mediiia';
    }
    if (isAgeytomesh) {
      return 'agey tomesh';
    }
    if (isMonaLisaTravels) {
      return 'Mona Lisa Travels'
    }
    if (isGalllleryArt) {
      return 'gallllery.art'
    }
    if (isDvaDesign) {
      return 'dva.design'
    }

    return getContextTitle(ctx);
  }

  const getPrefixName = () => {
    if (isLabDeziiign) {
      return 'lab'
    }
    if (isMediiiaUrban) {
      return 'urban'
    }
    if (isCompetition) {
      return 'awards'
    }
    if (isSuperPuper) {
      return 'superpuper.'
    }
    if (isBooksGallllery) {
      return 'books'
    }
    if (isCGRAVE) {
      return 'CG RAVE'
    }
    if (isAdcrDafesNet) {
      return 'ADCR'
    }
    if (isGreenAward) {
      return 'ЗЕЛЕНАЯ ПРЕМИЯ'
    }
    if (isContinuumSite) {
      return 'continuum'
    }
    if (isDafes || isProHSE) {
      return ''
    }
    if (isAcademy) {
      return 'creativecity.'
    }
    if (isBrnd) {
      if (isStartup) {
        return 'startup'
      }
      return ''
    }
    if (
      isGame ||
      isBookDeziiign ||
      isFashion ||
      isProDeziiign
    ) {
      return ctx;
    }
    return null;
  }

  const onClick = () => {
    if (isPortfoli365) {
      window.open(process.env.REACT_APP_URL_PORTFOLIO_365, '_self')
      return
    }
    if (isKiidsArt) {
      window.open(process.env.REACT_APP_URL_KIIIDS_ART, '_self')
      return
    }
    return
  }

  const onBurgerClick = useCallback(() => {
    if (
      modalName) {
      dispatch(modalControllerActions.hideModal({}));
    } else {

      if (isMobile || isTab) {
        dispatch(MobileMenuStateAction.toggle(!isOpen));
        dispatch(setIsOpen(!isOpen));
      } else {
        modal.show('context-new', {
          orientation: isHseSpace ? 'right' : 'center'
        });
      }
    }
  }, [
    isTagsModalActive,
    dispatch,
    modal,
    isMobile,
    isOpen,
    isCompetitionSendProjectActive
  ])

  const onLogoClick = useCallback((e: any) => {
    if (isPortfoli365) {
      window.open(process.env.REACT_APP_URL_PORTFOLIO_365, '_self')
      return
    }
    if (isKiidsArt) {
      window.open(process.env.REACT_APP_URL_KIIIDS_ART, '_self')
      return
    }
    if (isFooter && isMedia) {
      window.open(window.location.origin.endsWith('ru') ? process.env.REACT_APP_URL_MEDIIIA_RU : process.env.REACT_APP_URL_MEDIIIA_COM, '_self')
      return
    }
    if ((isAgeytomesh || isDvaDesign) && isMainPage && !!storedTeam?.longread && !storedTeam?.isLongreadDisabled) {
      e.preventDefault();
      e.stopPropagation();
      const path = isForcedLanding ? '/' : '/brnd';
      history.push(path);
    }
  }, [
    isFooter,
    isMedia,
    isPortfoli365,
    isAgeytomesh,
    isDvaDesign,
    isMainPage,
    storedTeam?.longread,
    storedTeam?.isLongreadDisabled,
    isForcedLanding,
    history
  ])

  const logoHref = useMemo(() => {
    if (isPortfoli365) {
      return process.env.REACT_APP_URL_PORTFOLIO_365;
    }
    if (isKiidsArt) {
      return process.env.REACT_APP_URL_KIIIDS_ART;
    }
    if (isFooter && isMedia) {
      return window.location.origin.endsWith('ru') ? process.env.REACT_APP_URL_MEDIIIA_RU : process.env.REACT_APP_URL_MEDIIIA_COM;
    }
    if ((isAgeytomesh || isDvaDesign) && isMainPage && !!storedTeam?.longread && !storedTeam?.isLongreadDisabled) {
      return isForcedLanding ? '/' : '/brnd';
    }
    return null;
  }, [isPortfoli365, isKiidsArt, isFooter, isMedia, isAgeytomesh, isDvaDesign, isMainPage, storedTeam?.longread, storedTeam?.isLongreadDisabled, isForcedLanding]);

  const prefixHref = useMemo(() => {
    return '/';
  }, [
    isFooter,
    isMedia,
    isPortfoli365,
    isAgeytomesh,
    isDvaDesign,
    isMainPage,
    storedTeam?.longread,
    storedTeam?.isLongreadDisabled,
    isForcedLanding,
    history
  ]);

  const prefixName = getPrefixName();
  const mainLogo = getTitleOrLogo({ hasPrefix: !!prefixName?.length });

  const simpleLogoVisible = useMemo(
    () => ((isHSEDesign || isSchool) && isHSEDesigner && !isDaMuseum) || isMedia || isLPU
    , [isHSEDesign, isDaMuseum, isHSEDesigner, isMedia, isSchool, isLPU])


  const shouldHideBurger = useMemo(() => {

    const isRestrictedFor1200BP = [
      isDaMuseum,
      isAgeytomesh,
      isHseAnimation,
      isContinuumSite,
      isDvaDesign,
      isGalllleryArt,
      isCGRAVE,
      isAdcrDafesNet,
      isGreenAward,
      isBrnd,
      isLPU,
      !!isCompetitionEdit,
      !!isHSEBookEdit
    ].some(Boolean) && !is1200BP;

    const isRestrictedForTablet = [
      isDafes,
      isGeo && !isDafes,
      isHseSpace,
      isHseColors,
      isCreativeHSE,
      isSchool,
      isPortfoli365,
      isLMSHSECreative,
      isKiidsArt
    ].some(Boolean) && !isTablet;

    const otherConditions = [
      isFooter,
      isMedia,
      isSuperPuper,
      !!isEditPage,
      !!isTeamEdit,
      !!isBookEdit,
      !!isCompetitionEdit,
      isMonaLisaTravels,
    ].some(Boolean);


    return isRestrictedFor1200BP || isRestrictedForTablet || otherConditions;
  }, [
    isAcademy,
    isTablet,
    isDafes,
    isGeo,
    isFooter,
    isDaMuseum,
    isHseAnimation,
    isHseColors,
    isLMSHSECreative,
    isCreativeHSE,
    isSchool,
    isAgeytomesh,
    isEditPage,
    isContinuumSite,
    isMedia,
    isBrnd,
    is992BP,
    isSuperPuper,
    isDvaDesign,
    isGalllleryArt,
    isCGRAVE,
    isAdcrDafesNet,
    isGreenAward,
    isPortfoli365,
    isLPU,
    is1200BP,
    isTeamEdit,
    isBookEdit,
    isCompetitionEdit,
    isHSEBookEdit,
    isHseSpace,
    isMonaLisaTravels,
  ]);

  const logoStyle = () => {
    if (!isFooter && isTablet) {
      return '3linesgrey'
    }
    if (isDafes) {
      return 'mobile';
    }
    if ((isDvaDesign || isAgeytomesh || isHseAnimation || isGalllleryArt || (isMedia && is992BP)) && !isFooter) {
      return '4lines';
    }
    return 'default'
  }

  const onMainContextClick = useCallback((e: any) => {
    e.preventDefault()
    e.stopPropagation()
    if (typeof mainLogo === 'string' && ['.deziiign', 'deziiign']?.includes(mainLogo)) {
      window.open(process.env.REACT_APP_URL_DEZIIIGN, '_self');
      return;
    }
    if (isBooksGallllery) {
      window.open(process.env.REACT_APP_URL_GALLERY, '_self')
      return
    }

    history.push('/')

  }, [mainLogo, history])

  const postfixHref = useMemo(() => {
    if (typeof mainLogo === 'string' && ['.deziiign', 'deziiign']?.includes(mainLogo)) {
      return process.env.REACT_APP_URL_DEZIIIGN;
    }
    if (isBooksGallllery) {
      return process.env.REACT_APP_URL_GALLERY;
    }

    return '/';
  }, [isPortfoli365, isKiidsArt, isBooksGallllery, mainLogo]);

  const handlers = {
    onClick: onBurgerClick,
    onBurgerClick,
  }

  const getNavbarProps = () => {
    if (isFooter) {
      return {
        theme: navbarTheme,
        title: mainLogo === '.deziiign' ? 'deziiign' : mainLogo,
        visiblePopUp: false,
        logoLength: AGEYTOMESH_LOGO_LENGTH,
        prefixName: mainLogo === '.deziiign' ? '' : prefixName,
        prefixColor: prefixColor,
        postfixColor: postfixColor,
        shouldHideBurger: true,
        logoStyle: "default",
        disabled: navDisabled,
        isFooter: true,
        ...(isAcademy && { postfixHref }),
        onBurgerClick: () => {
          return
        },
      }
    }
    return {
      theme: navbarTheme,
      title: isFooter && mainLogo === '.deziiign' ? 'deziiign' : mainLogo,
      ...(isDafes && isTablet && { earlyMobile: true }),
      visiblePopUp: isOpen || isTagsModalActive || !!modalName,
      logoLength: AGEYTOMESH_LOGO_LENGTH,
      prefixName: isFooter && mainLogo === '.deziiign' ? '' : prefixName,
      prefixColor: prefixColor,
      isLight: isBooksGallllery,
      postfixColor: postfixColor,
      shouldHideBurger: shouldHideBurger,
      logoStyle: logoStyle(),
      isShifted: (isAgeytomesh && logoShifted && isHseAnimation && !isMobile && !isEditPage && !isProjectPage),
      isOnlines: isOnlines,
      logoLikeTag: isAgeytomesh || isHseAnimation || isDvaDesign || isGalllleryArt || isMonaLisaTravels,
      disabled: navDisabled,
      onBurgerClick,
      logoHref,
      postfixHref,
      prefixHref,
    }
  }

  const handleReloadPage = useCallback(() => {
    if (isTeamOrCoursePage && isHSEDesign) {
      history.push(LinkTo.explore);
      window.location.reload();
    }
  }, [isTeamOrCoursePage, isHSEDesign]);

  if (simpleLogoVisible) {
    return (
      <SimpleLogoContainer align={'center'} style={{ maxWidth: isMedia ? 'none' : '490px' }}>
        {!shouldHideBurger && (
          <NavbarBurger
            style={{ marginRight: '8px', marginTop: isTablet ? '2px' : '0' }}
            {...handlers}
          >
            {isOpen || isTagsModalActive || !!modalName ? (
              <NavbarCloseIconWithBorder />
            ) : (
              (isTablet ? <NavbarThreeLinesIcon fill={Colors.galBlack47} /> : <NavbarBContextSelectIcon />)
            )}
          </NavbarBurger>
        )}
        {isMedia ? (
          <MediiiaLogo
            {...handlers}
            isFooter={isFooter}
            visiblePopUp={isOpen}
          />
        ) : isLPU ? (
          <LPULogo onClick={() => history.push('/')} />
        ) : isHseSpace? (
          <ExternalLink to={process.env.REACT_APP_URL_HSE_SPACE} title={extractDomain('/')}>
            {mainLogo}
          </ExternalLink>
        ) : (
          <NeutralLink to={LinkTo.explore} onClick={handleReloadPage} title={extractDomain('/')}>
            {mainLogo}
          </NeutralLink>
        )}
      </SimpleLogoContainer>
    )
  }

  return (
    <>
      {isDafes && <DafesStyles />}
      <NavbarBlackOrWhite isOpen={isOpen} isKiidsArt={isKiidsArt} {...getNavbarProps()} />
    </>
  )
}